import React from "react";

const GLYPHS = {
  positive: "M2 6.4L5 9.4L10.5 3",
  negative: "M6 3.2v4M6 9.2v.2",
  warning: "M6 3.2v4M6 9.2v.2",
  info: "M6 5.6v3.6M6 3.2v.2",
};

export function Toast({ tone = "neutral", title, description, action = null, onClose, className = "", ...rest }) {
  const toneFg = tone === "neutral" ? "var(--text-muted)" : `var(--feedback-${tone}-fg)`;
  const toneBg = tone === "neutral" ? "var(--surface-inset)" : `var(--feedback-${tone}-bg)`;
  return (
    <div className={`ca-toast ${className}`} role="status" style={{ position: "relative" }} {...rest}>
      <span className="ca-toast__icon" style={{ background: toneBg, color: toneFg }}>
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
          <path d={GLYPHS[tone] || GLYPHS.info} />
        </svg>
      </span>
      <div className="ca-toast__body">
        <div className="ca-toast__title">{title}</div>
        {description ? <div className="ca-toast__desc">{description}</div> : null}
        {action ? <div style={{ marginTop: "var(--space-4)" }}>{action}</div> : null}
      </div>
      {onClose ? (
        <button type="button" className="ca-iconbtn ca-iconbtn--sm" aria-label="Dismiss" onClick={onClose}>
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
            <path d="M2.5 2.5l7 7M9.5 2.5l-7 7" />
          </svg>
        </button>
      ) : null}
    </div>
  );
}
